(function($){
  OH.settings.lineClamp = (function(){
    var control = new Object();
    /**
     * 表示文字制限
     * stringLength 以上は三点リーダに変更
     * 説明文の oo文字以上 は三点リーダ
     * @param {Object}
     * @param {Num} 制限文字数
     */
    control.strengLength = function($summaryElment, stringLength){
       var cutFigure = stringLength;
       var clampText = '...';
       $summaryElment.each(function() {
         var textLength = $(this).text().length;
         var textTriming = $(this).text().substr(0, cutFigure);
         if (cutFigure < textLength) {
           $(this).text(textTriming + clampText);
         }
      });
    }
    
    /**
     * heightによってclampする
     */
    // eachでのwhile処理が非常に重くなるため、cssでellipse  
    // control.heightClamp = function($targetElment){
    //   var words = $targetElment.text();
      // // console.log(words);
      // while ($targetElment.get(0).scrollHeight > $targetElment.get(0).offsetHeight) {
      //   words = words.substr(0,words.length - 1);// + (extendText || "...");
      // }
      // console.log(
      //   $targetElment.get(0).scrollHeight,
      //   $targetElment.get(0).offsetHeight,
      // //   $wraps.get(0).scrollHeight,
      //   words
      // );
    // }
  return control;
  })();
})(jQuery);
